import $axios from '~/plugins/axios';

import { Api, CampaignVisual, GetCampaignVisualParams, PaginatorResult } from '~/api';
import { buildModule, createFiltersModule, createPaginationModule, defineArrayFilter, defineSingleFilter } from '../utils';
import { Dict, createDict } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withSubmodules({
		pagination: createPaginationModule({
			pageQueryKey: 'campaignVisualsPage',
			pageSizeQueryKey: 'campaignVisualsPerPage',
			itemCountGetter: 'campaignVisuals/list/totalCount',
		}),
		filters: createFiltersModule({
			filters: {
				searchTerm: defineSingleFilter('search', String),
				type: defineSingleFilter('type', String),
				from: defineSingleFilter('from', String),
				to: defineSingleFilter('to', String),
				tags: defineArrayFilter('tags', Number),
				customFilterIds: defineArrayFilter('customFilterIds', Number),
				customFilterValues: defineArrayFilter('customFilterValues', String),
			},
		}),
	})
	.withState({
		storedCampaignVisuals: {} as Dict<CampaignVisual>,
		campaignVisuals: [] as CampaignVisual[],
		loading: false,
		paginator: null as PaginatorResult | null,
	})
	.withGetters({
		byId: state => (campaignVisualId: number) => (
			state.storedCampaignVisuals[campaignVisualId] ?? null
		),
		page: state => state.campaignVisuals,
		loading: state => state.loading,
		totalCount: state => state.paginator?.totalCount ?? 0,
	})
	.withMutations({
		SET_STORED_CAMPAIGN_VISUALS (state, campaignVisuals: CampaignVisual[]) {
			state.storedCampaignVisuals = {
				...state.storedCampaignVisuals,
				...createDict(campaignVisuals, (visual) => visual.id),
			};
		},
		SET_CAMPAIGN_VISUALS (state, campaignVisualIds: number[]) {
			state.campaignVisuals = campaignVisualIds.map(id => state.storedCampaignVisuals[id]);
		},
		SET_LOADING (state, loading: boolean) {
			state.loading = loading;
		},
		SET_PAGINATOR (state, paginator: PaginatorResult) {
			state.paginator = paginator;
		},
	})
	.withActions({
		async get ({ commit }, params: GetCampaignVisualParams = {}) {
			commit('SET_LOADING', true);
			const { data } = await api.get('/campaign-visual', { params });
			commit('SET_LOADING', false);

			const campaignVisuals = data.payload;
			const campaignVisualIds = campaignVisuals.map(visual => visual.id);

			commit('SET_STORED_CAMPAIGN_VISUALS', campaignVisuals);
			commit('SET_CAMPAIGN_VISUALS', campaignVisualIds);
			commit('SET_PAGINATOR', data.paginator);
		},
	});
